import React, { useState } from "react";
import { LoginAPI } from "../../api/auth";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import "./login.css";

function Login() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!email) {
      newErrors = {
        ...newErrors,
        email: "Email is required",
      };
    }

    if (!password) {
      newErrors = {
        ...newErrors,
        password: "Password is required",
      };
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length) {
      return;
    }
    setLoading(true);
    const payload = {
      email,
      password,
    };

    const res = await LoginAPI(payload);
    if (res.remote === "success") {
      localStorage.setItem("token", res.data.token);
      navigate("/");
    } else {
      setErrors(res.error);
    }
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card_title">
          <h1>Login Page</h1>
        </div>
        <form onSubmit={handleSubmit} className="form">
          <div>
            <span>Email</span>
            <input
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.email}
            </span>
          </div>
          <div>
            <span>Password</span>
            <input
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.password}
            </span>
          </div>
          <span style={{ color: "red", fontSize: "12px" }}>
            {errors.message}
          </span>
          <button type="submit" className="loginBtn" disabled={loading}>
            {loading ? <CircularProgress /> : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
